const buster = Math.floor(Math.random() * 100);

export default buster;
